export type Txn = { type: string; amount: number; created_at: string };

export type MonthUsage = { month: string; key: string; credits: number };

export type BreakdownRow = {
  label: string;
  credits: number;
  icon: string;
  tone: 'success' | 'accent' | 'warning' | 'texts';
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function monthKey(d: Date) {
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

function parseCreated(iso: string): Date | null {
  if (!iso) return null;
  const t = new Date(iso);
  return Number.isNaN(t.getTime()) ? null : t;
}

export function usageFromTransactions(txns: Txn[], now = new Date()): {
  months: MonthUsage[];
  thisMonth: number;
  hosted: number;
  breakdown: BreakdownRow[];
} {
  const months: MonthUsage[] = [];
  const byKey: Record<string, MonthUsage> = {};
  for (let i = 5; i >= 0; i--) {
    const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i, 1));
    const row: MonthUsage = { month: MONTHS[d.getUTCMonth()], key: monthKey(d), credits: 0 };
    months.push(row);
    byKey[row.key] = row;
  }

  let hosted = 0;
  let refunds = 0;
  const thisKey = monthKey(new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1)));

  for (const t of txns) {
    const when = parseCreated(t.created_at);
    if (t.type === 'hosted_usage') {
      hosted += t.amount;
      if (when) {
        const row = byKey[monthKey(new Date(Date.UTC(when.getUTCFullYear(), when.getUTCMonth(), 1)))];
        if (row) row.credits += t.amount;
      }
    }
    if (t.type === 'hosted_refund') {
      refunds += t.amount;
    }
  }

  const thisMonth = byKey[thisKey]?.credits ?? 0;
  const breakdown: BreakdownRow[] = [
    { label: 'Hosted scores', credits: hosted, icon: 'ri-dashboard-line', tone: 'success' },
    { label: 'Refunds', credits: refunds, icon: 'ri-refund-2-line', tone: 'accent' },
    { label: 'Local schema tests', credits: 0, icon: 'ri-checkbox-circle-line', tone: 'texts' },
  ];

  return { months, thisMonth, hosted, breakdown };
}
